import type { ReactNode } from 'react';

type ContentSectionProps = {
  id: string;
  title: string;
  hint?: string;
  alt?: boolean;
  children?: ReactNode;
};

export default function ContentSection({ id, title, hint, alt = false, children }: ContentSectionProps) {
  return (
    <section id={id} className={`scroll-mt-24 px-4 md:px-10 py-16 md:py-24 ${alt ? 'bg-background-100' : 'bg-background-50'}`}>
      <div className="max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-block w-10 h-1 rounded-full bg-accent-500 mb-5"></span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">{title}</h2>
        </div>
        <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-5 sm:p-6 md:p-10">
          <div
            className="max-w-3xl text-foreground-700 text-sm md:text-base leading-relaxed space-y-4 text-left md:text-justify hyphens-none
              [&_h2]:font-heading [&_h2]:text-2xl md:[&_h2]:text-3xl [&_h2]:font-semibold [&_h2]:text-foreground-950 [&_h2]:mt-8 [&_h2]:first:mt-0
              [&_h3]:font-heading [&_h3]:text-xl md:[&_h3]:text-2xl [&_h3]:font-semibold [&_h3]:text-foreground-950 [&_h3]:mt-6
              [&_p]:text-foreground-700
              [&_strong]:text-foreground-950 [&_strong]:font-semibold
              [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2
              [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-2
              [&_li]:text-left
              [&_a]:text-primary-600 [&_a]:underline [&_a]:cursor-pointer"
          >
            {hint && <p className="text-xs italic text-foreground-500 text-left">{hint}</p>}
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}